export interface ScannedProduct {
  title: string
  editionLabel: string
  priceNumber: number
  priceText: string
  thumbnailUrl: string
}

const DEFAULT_PRODUCTS: ScannedProduct[] = [
  {
    title: 'Pack Despertar / Physical Book',
    editionLabel: 'Physical Edition',
    priceNumber: 27,
    priceText: '$27.00',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png',
  },
  {
    title: 'Edición Digital / Digital Edition',
    editionLabel: 'Digital Edition',
    priceNumber: 17,
    priceText: '$17.00',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png',
  },
]

export function scanForProducts(): ScannedProduct[] {
  const products: ScannedProduct[] = []

  // Strategy A: JSON-LD
  const scripts = document.querySelectorAll(
    'script[type="application/ld+json"]',
  )
  scripts.forEach((script) => {
    try {
      const data = JSON.parse(script.textContent || '')
      if (data['@type'] === 'Product' || data['@type'] === 'Offer') {
        const price = data.offers?.price || data.price
        const priceCurrency =
          data.offers?.priceCurrency || data.priceCurrency || 'USD'
        if (data.name && price) {
          products.push({
            title: data.name,
            editionLabel: 'Standard Edition',
            priceNumber: parseFloat(price),
            priceText: `${priceCurrency === 'USD' ? '$' : ''}${price}`,
            thumbnailUrl:
              data.image ||
              'https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png',
          })
        }
      }
    } catch (e) {
      // Ignore parse errors
    }
  })

  if (products.length > 0) return products

  // Strategy B: DOM Scanning (Fallback)
  // Look for common price patterns like $9.39 or 27 USD
  const priceRegex = /\$\s?(\d+(?:\.\d{2})?)/
  const bodyText = document.body.innerText

  // Try to find the specific product on this page (The Nighttime Cortisol Code)
  const offerSection = document.getElementById('offer-section')
  if (offerSection) {
    const text = offerSection.innerText
    const match = text.match(priceRegex)
    if (match) {
      products.push({
        title: 'The Nighttime Cortisol Code',
        editionLabel: 'Digital Edition',
        priceNumber: parseFloat(match[1]),
        priceText: `$${match[1]}`,
        thumbnailUrl:
          'https://cdn.magicpatterns.com/uploads/bdc9xrahdoVLsRamzXhStN/The_Nighttime_Cortisol_Code.png',
      })
      return products
    }
  }

  // If nothing found, return default products
  return DEFAULT_PRODUCTS
}

export function getRandomProduct(products: ScannedProduct[]): ScannedProduct {
  if (products.length === 0) return DEFAULT_PRODUCTS[0]

  // If we're using the default products, apply the 70/30 split logic
  if (products === DEFAULT_PRODUCTS) {
    const rand = Math.random()
    return rand < 0.7 ? DEFAULT_PRODUCTS[0] : DEFAULT_PRODUCTS[1]
  }

  // Otherwise pick a random detected product
  const randomIndex = Math.floor(Math.random() * products.length)
  return products[randomIndex]
}
